var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cd-energy-efficiency-box-wrapper" },
    [
      _c("h3", { domProps: { innerHTML: _vm._s(_vm.popoverTitle) } }),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col"),
              _c("b-col", [
                _vm.hasSecondaryClass
                  ? _c("span", [_vm._v("gewichtet kombiniert")])
                  : _vm._e()
              ]),
              _c("b-col", [
                _vm.hasSecondaryClass
                  ? _c("span", [_vm._v("bei entladener Batterie")])
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { class: "cd-energy-efficiency-box" + _vm.boxClassAddition }, [
        _vm.hasSecondaryClass
          ? _c("span", { staticClass: "cd-energy-efficiency-box-spacer" })
          : _vm._e(),
        _c("span", { class: "energy-efficiency-marker " + _vm.markerClass }, [
          _vm._v(
            _vm._s(
              _vm.hasSecondaryClass ? _vm.getCo2ClassOnly : _vm.getCo2Class
            )
          )
        ]),
        _vm.hasSecondaryClass
          ? _c(
              "span",
              {
                class:
                  "energy-efficiency-marker secondary " +
                  _vm.secondaryMarkerClass
              },
              [_vm._v(_vm._s(_vm.getSecondaryCo2Class))]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }